// Components
// Utilities
import compact from "lodash/compact";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
/**
 * Set focus on the correct item before an item is removed from a list of items. Use generic item type and provide callbacks to get the element and ID.
 * @param items Array of items of type T that are identified with a string ID and contain an HTMLElement
 * @param setFocusOnAlt Callback to set focus elsewhere if the last item is being removed
 * @param removeItemId ID of the item being removed
 * @param getItemId Delegate to get the ID from type T
 * @param getItemElement Delegate to get the HTMLElement from type T
 */ export function ChangeFocusBeforeRemoval(items, setFocusOnAlt, removeItemId, getItemId, getItemElement) {
    let removeAtIndex = -1;
    const elements = compact(map(items, (item, index)=>{
        if (removeItemId === getItemId(item)) {
            removeAtIndex = index;
            return null;
        }
        return getItemElement(item);
    }));
    if (removeAtIndex > -1) {
        RestoreFocusAfterRemoval(elements, setFocusOnAlt, removeAtIndex);
    }
}
/**
 * Set focus on the correct item before an item is removed from a list of items. Use the IFocusableElement wrapper to pass in the elements and IDs.
 * @param items Array of IFocusableElements that are identified with a string ID and contain an HTMLElement
 * @param setFocusOnAlt In the case that the last item was removed from the list of items, provide a callback to set focus on the correct element
 * @param removeItemId ID of the item being removed
 */ export function ChangeFocusBeforeRemovalIFocusable(items, setFocusOnAlt, removeItemId) {
    ChangeFocusBeforeRemoval(items, setFocusOnAlt, removeItemId, (item)=>{
        return item.id;
    }, (item)=>{
        return item.element;
    });
}
/**
 * Set focus after an item with focus has been removed from a list of items.
 * @param focusableElements The current elements in the list of elements (exclude removed item)
 * @param setFocusOnAlt In the case that the last item was removed from the list of items, provide a callback to set focus on the correct element
 * @param removedFromIndex The index at which the item was removed
 */ export function RestoreFocusAfterRemoval(focusableElements, setFocusOnAlt, removedFromIndex) {
    if (isEmpty(focusableElements)) {
        setFocusOnAlt();
    } else if (removedFromIndex < focusableElements.length) {
        focusableElements[removedFromIndex].focus();
    } else {
        focusableElements[focusableElements.length - 1].focus();
    }
}
/**
 * Set the focusable state of an element by setting its tabindex attribute.
 * @param element The element to set the focusable state on
 * @param focusable Whether the element should be focusable (true) or not (false)
 */ export const setElementFocusableState = (element, focusable)=>{
    element.setAttribute("tabindex", focusable ? "0" : "-1");
};
